if (!customElements.get('gg-coffee-discovery')) {
  customElements.define('gg-coffee-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('.ggl-discovery-track');
      this.previous = this.querySelector('[data-discovery-prev]');
      this.next = this.querySelector('[data-discovery-next]');
      this.controls = this.querySelector('.ggl-discovery-controls');
      this.status = this.querySelector('[data-discovery-status]');
      if (!this.track || !this.previous || !this.next) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      let sitePaused = false;
      try {
        const saved = sessionStorage.getItem('ggx-living-motion-paused');
        sitePaused = saved === 'true' || saved === '1';
      } catch {}
      this.paused = this.paused === true || this.motion.matches || sitePaused;
      this.previewDone = this.previewDone === true;
      this.previewStarted = this.previewStarted === true;
      window.addEventListener('ggx:motion-preference', event => {
        if (event.detail?.paused === true) this.pause();
      }, options);
      this.inView = false;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.direction = 1;
      this.previous.addEventListener('click', () => this.manual(-1), options);
      this.next.addEventListener('click', () => this.manual(1), options);
      for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin']) {
        this.addEventListener(type, () => this.pause(), { ...options, capture: true, passive: true });
      }
      this.addEventListener('pointerenter', event => {
        if (event.target === this) this.pause();
      }, { ...options, passive: true });
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); this.pause();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.track.scrollWidth);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.pause(); return; }
        this.syncPlayback();
      }, options);
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2; this.schedule();
      }, { threshold: 0.2 });
      this.visibility.observe(this);
      this.resize = new ResizeObserver(() => { this.update(); this.schedule(); });
      this.resize.observe(this.track);
      this.update(); this.syncPlayback();
    }
    pause() {
      clearTimeout(this.autoTimer); clearTimeout(this.previewStopTimer);
      this.autoTimer = null; this.previewStopTimer = null;
      this.previewDone = true;
      this.paused = true;
      this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
      this.syncPlayback();
    }
    manual(direction) { this.pause(); this.move(direction); }
    syncPlayback() {
      this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      this.schedule();
    }
    schedule() {
      const available = this.isConnected && !this.paused && !this.motion.matches && !this.contains(document.activeElement) && this.inView && !document.hidden && this.track.scrollWidth - this.track.clientWidth >= 2;
      if (!available) {
        if (this.previewStarted && !this.paused) this.pause();
        return;
      }
      if (this.previewDone || this.previewStarted) return;
      this.previewStarted = true;
      this.autoTimer = setTimeout(() => {
        this.autoTimer = null;
        if (!this.isConnected || this.paused || this.motion.matches || this.contains(document.activeElement) || !this.inView || document.hidden) { this.pause(); return; }
        this.previewDone = true;
        this.move(1);
        this.previewStopTimer = setTimeout(() => this.pause(), 1000);
      }, 3500);
    }
    move(direction) {
      const first = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.go(this.track.scrollLeft + direction * ((first?.getBoundingClientRect().width || this.track.clientWidth) + gap));
    }
    go(left) {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.track.scrollTo({ left: Math.max(0, Math.min(left, maximum)), behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = maximum < 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        const bounds = this.track.getBoundingClientRect();
        const cards = [...this.track.children];
        const visible = cards.map((card, index) => ({ index, box: card.getBoundingClientRect() })).filter(item => item.box.right > bounds.left + 8 && item.box.left < bounds.right - 8);
        if (visible.length) this.status.textContent = `Coffees ${visible[0].index + 1}–${visible[visible.length - 1].index + 1} of ${cards.length}`;
      }, 180);
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null;
      this.resize?.disconnect(); this.visibility?.disconnect();
      clearTimeout(this.statusTimer); clearTimeout(this.autoTimer); clearTimeout(this.previewStopTimer);
      if (this.previewStarted) this.previewDone = true;
      this.autoTimer = null; this.previewStopTimer = null;
    }
  });
}
